import { createSlice } from '@reduxjs/toolkit'
import { requestState } from '../type/type'
import { fetchAllTopics, createTopic, updateTopic, deleteTopic } from './topicActions'

const initialState = {
  topics: [],
  status: requestState.idle,
  error: null,
}

const topicSlice = createSlice({
  name: 'topic',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllTopics.pending, (state) => {
        state.status = requestState.loading
      })
      .addCase(fetchAllTopics.fulfilled, (state, action) => {
        state.status = requestState.success
        state.topics = action.payload
      })
      .addCase(fetchAllTopics.rejected, (state, action) => {
        state.status = requestState.failed
        state.error = action.error.message
      })
      .addCase(createTopic.fulfilled, (state, action) => {
        state.topics.push(action.payload)
      })
      .addCase(updateTopic.fulfilled, (state, action) => {
        const index = state.topics.findIndex(topic => topic.id === action.payload.id)
        if (index !== -1) {
          state.topics[index] = action.payload
        }
      })
      .addCase(deleteTopic.fulfilled, (state, action) => {
        state.topics = state.topics.filter(topic => topic.id !== action.meta.arg)
      })
  },
})

export const topicReducer = topicSlice.reducer
